import React from "react";
import { Link } from "react-router-dom";
import { Type } from "@ebscois/react-component-library";
import GenericTable from "../GenericTable";
import {
  SyledTablesList,
  StyledTableWrapper,
  StyledViewInTopic,
} from "./_.styled";
import {
  affordances,
  logTableViewInContextClicked,
} from "../../util/analytics";

const { TOPIC_GALLERY } = affordances;

const TablesTab = ({
  tablesContent,
  ancillaryData,
  setIsDialogOpen,
  setTableData,
  slugTitle,
  slugPubType,
  isNonFreePreview,
  handleOpenTable,
}) => {
  const { tables = [] } =
    (ancillaryData.length &&
      ancillaryData.find(({ type }) => type === "TablesRightRailSection")) ||
    {};

  return (
    <div data-testid="tables-tab">
      <Type element="p">
        This list{" "}
        <Type element="strong">does not include unnumbered tables</Type> that
        may exist within the details section of Study Summaries.
      </Type>

      {!!tables.length && (
        <SyledTablesList type="ul" noIndicator={true} data-testid="tables-list">
          {tables.map(({ id, title, caption, standAlone }) => {
            return (
              <StyledTableWrapper key={id}>
                <GenericTable
                  setIsDialogOpen={setIsDialogOpen}
                  setTableData={setTableData}
                  children={tablesContent[id]}
                  tableText={title}
                  tableCaption={caption}
                  isStandAlone={standAlone}
                  tableId={id}
                  affordance={TOPIC_GALLERY}
                  isNonFreePreview={isNonFreePreview}
                  handleOpenTable={handleOpenTable}
                />
                <StyledViewInTopic
                  linkComponent={Link}
                  href={`/${slugPubType}/${slugTitle}#${id.toUpperCase()}`}
                  data-testid="view-in-topic"
                  onClick={() =>
                    logTableViewInContextClicked({
                      title: `${title} ${caption}`,
                      tableId: id,
                      affordance: TOPIC_GALLERY,
                    })
                  }
                >
                  View in topic
                </StyledViewInTopic>
              </StyledTableWrapper>
            );
          })}
        </SyledTablesList>
      )}
    </div>
  );
};

export default TablesTab;
